module.exports = __webpack_public_path__ + "static/media/YF80_3.079a099b.jpg";